import { QueryKeyFactory } from './types';

/**
 * A utility function to create a query key factory.
 */
const createQueryKey = <T extends QueryKeyFactory>(keyObject: T): T => keyObject;

/**
 * A utility reference to the return type of the createQueryKey function.
 */

type CreateQueryKey = ReturnType<typeof createQueryKey>;

export { createQueryKey, type CreateQueryKey };
